import type { RegistratieVersie } from '@/types/domain';
import { ServiceFout, type HistorieService } from '../types';
import { getHuidigeRol } from '../rolContext';
import { getSupabase, leesbareFout } from './supabaseClient';
import { vanRij, type RegistratieRij } from './rowMapping';

/**
 * Eerdere versies van een registratie.
 *
 * De momentopname is de volledige rij zoals hij was, dus inclusief
 * persoonsgegevens. De gemeente leest daarom uit een weergave waarin die
 * velden uit de momentopname zijn verwijderd — net als bij de registraties
 * zelf is dat een aparte bron in de database, geen filter in de app.
 */

const TABEL = 'registratie_historie';
const GEMEENTE_WEERGAVE = 'registratie_historie_gemeente';

interface HistorieRij {
  id: string;
  registratie_id: string;
  versie: number;
  vervangen_op: string;
  coach: string;
  momentopname: RegistratieRij;
}

export const supabaseHistorieService: HistorieService = {
  async haalVoor(registratieId: string): Promise<RegistratieVersie[]> {
    const bron = getHuidigeRol() === 'gemeente' ? GEMEENTE_WEERGAVE : TABEL;

    const { data, error } = await getSupabase()
      .from(bron)
      .select('*')
      .eq('registratie_id', registratieId)
      .order('versie', { ascending: false });

    if (error) throw new ServiceFout(leesbareFout(error), error);

    return ((data ?? []) as HistorieRij[]).map((rij) => ({
      id: rij.id,
      registratieId: rij.registratie_id,
      versie: rij.versie,
      vervangenOp: rij.vervangen_op,
      coach: rij.coach,
      momentopname: vanRij(rij.momentopname),
    }));
  },
};
